import { render, staticRenderFns } from "./ImageMessage.vue?vue&type=template&id=db76af06&scoped=true"
import script from "./ImageMessage.vue?vue&type=script&lang=js"
export * from "./ImageMessage.vue?vue&type=script&lang=js"
import style0 from "./ImageMessage.vue?vue&type=style&index=0&id=db76af06&prod&lang=scss&scoped=true"
import style1 from "./ImageMessage.vue?vue&type=style&index=1&id=db76af06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db76af06",
  null
  
)

export default component.exports